import React from 'react';
import { connect } from 'react-redux';
import Table from '.';
import { mapDispachToProps, mapStateToProps } from "../../store/MapToProps";

import { adminStructure } from '../../data_formats';

const AdminUserTable = (props) => {
  React.useEffect(() => {
    props.getAllUsers()
  }, [])
  return (
    <>
      <Table
        title={"Admins"}
        pageTitle={"Admin"}
        columns={adminStructure}
        rows={props.users.users}
        rowsPerPage={50}
        pageSize={10}
        fieldKey={"adminStructure"}
        dataKey={"users"}
        {...props}
      />
    </>
  )
}


export default connect(mapStateToProps, mapDispachToProps)(AdminUserTable);